<template>
  <div id="bottomLeft">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span style="color: #5cd9e8">
          <i class="iconfont iconcheliang-"></i>
        </span>
        <span class="fs-xl text mx-2">最近十辆缴费车辆</span>
      </div>
      <div class="d-flex jc-center body-box">
        <!-- <dv-scroll-board :config="config" style="width:100%;" /> -->
        <div class="tabList">
          <span>所属车场</span>
          <span>车牌号码</span>
          <span>缴费金额</span>
          <span>支付时间</span>
          <span>支付场景</span>
        </div>
        <vueSeamless
          :data="listData"
          :class-option="optionSingleHeight"
          class="seamless-warp"
        >
          <ul class="item">
            <li v-for="(item, index) in listData" :key="index">
              <span class="parkName" v-text="item.parkName"></span>
              <span class="plate" v-text="item.plate"></span>
              <span class="money" v-text="item.amount + '元'"></span>
              <span class="money" v-text="item.createTime"></span>
              <span class="payScene" v-text="item.payScene"></span>
            </li>
          </ul>
        </vueSeamless>
      </div>
    </div>
  </div>
</template>

<script>
import vueSeamless from "vue-seamless-scroll";
export default {
  data() {
    return {
      listData: [],
      fiveInterval: "",
    };
  },
  components: {
    vueSeamless,
  },
  mounted() {
    this.submitGetMessageList();
  },
  methods: {
    submitGetMessageList() {
      const that = this;
      that.$store.dispatch("getMessageList", 5); //$dispatch在vue2中已废除，此处用的是elementUI中的方法，触发actions
      this.fiveInterval = setInterval(() => {
        that.$store.dispatch("getMessageList", 5); //$dispatch在vue2中已废除，此处用的是elementUI中的方法，触发actions
      }, 10000);
    },
  },
  computed: {
    optionSingleHeight() {
      return {
        singleHeight: 32,
      };
    },
  },
  beforeDestroy () {
    clearInterval(this.fiveInterval);
    this.fiveInterval = null;
  },
  watch: {
    // watch 可以监听 data 数据 也可以监听 全局 vuex数据
    //监听vuex中userNumber的变化
    "$store.state.recently"(val) {
      //变化之后根据自己项目需求写自身的逻辑代码，下面只是示例
      this.listData = val;
    },
  },
};
</script>

<style lang="scss" scopd>
#bottomLeft {
  height: 100%;
  min-width: 3.75rem;
  border-radius: 0.0625rem;
  .bg-color-black {
    height: 6.0625rem;
    border-radius: 0.125rem;
    .body-box {
      margin-top: 0 !important;
      .tabList {
        margin-top: 0.1rem;
        display: flex;
        span {
          flex: 1;
          font-size: 0.18rem;
          text-align: center;
        }
      }
      .seamless-warp {
        margin-top: 0.1rem;
        height: 2.4rem;
        overflow: hidden;
        .item > li {
          display: flex;
          height: 0.4rem;
          line-height: 0.4rem;
          span {
            flex: 1;
            text-align: center;
            font-size: 0.15rem;
          }
        }
        .item > li:nth-child(odd) {
          background-color: rgba(#0e1c35,0.5);
        }
      }
    }

    .iconfont {
      color: #71aa5b;
      font-size: 0.25rem;
    }
  }
  .text {
    color: #c3cbde;
  }
  .chart-box {
    margin-top: 0.2rem;
    width: 2.125rem;
    height: 2.125rem;
    .active-ring-name {
      padding-top: 0.125rem;
    }
  }
}
</style>